/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, ViewRef} from '@angular/core';

/**
 * Applies view-bound state on the next macrotask, then markForCheck.
 *
 * Prefer importing from `./template-state` (deferViewWrite / deferMarkForCheck)
 * so new code uses the unified template-state API.
 *
 * Prefer sync apply in AdnHttp Promise.then handlers — AdnHttp already settles
 * after HttpClient's zoneless tick. Use this only for non-HTTP paths that flip
 * bindings during an existing change-detection turn (sync validation, cache
 * replay, etc.).
 */
export function deferMarkForCheck(cdr: ChangeDetectorRef, apply: () => void): void {
  setTimeout(() => {
    const view = cdr as ViewRef;
    if (view.destroyed) {
      return;
    }
    apply();
    cdr.markForCheck();
  });
}
